import { BULK_INTERNAL_ROLES } from '../constants';
import type { BulkConfirmStatus, BulkImportError, BulkUserType } from '../types';

export function getBulkUserTypeLabel(userType: BulkUserType): string {
  return userType === 'internal' ? 'Usuário interno' : 'Usuário cliente';
}

export function getBulkRoleLabel(role: string): string {
  return BULK_INTERNAL_ROLES.find((item) => item.value === role)?.label ?? role;
}

export function getBulkRowStatusLabel(status: 'valid' | 'invalid'): string {
  return status === 'valid' ? 'Válido' : 'Com erro';
}

export function getBulkConfirmStatusLabel(status: BulkConfirmStatus): string {
  if (status === 'created') return 'Criado';
  if (status === 'skipped') return 'Ignorado';
  return 'Falhou';
}

export function getFieldError(
  row: { errors?: BulkImportError[] } | null | undefined,
  field: string
): string | undefined {
  return row?.errors?.find((error) => error.field === field)?.message;
}

export function getFieldLabel(field: string): string {
  const labels: Record<string, string> = {
    nome: 'Nome',
    email: 'E-mail',
    role: 'Role',
    whatsapp: 'WhatsApp',
  };
  return labels[field] ?? field;
}

export function formatRowErrors(errors: BulkImportError[]): string {
  if (errors.length === 0) return '';
  return errors.map((error) => `${getFieldLabel(error.field)}: ${error.message}`).join(' · ');
}
